export default [
  "updated",
  "modified_by",
  "delegated_at",
  "delegated_by",
  "priority",
  "slug"
];
